import React from 'react';
import { createRoot } from 'react-dom/client'
import Root from './routes';
import * as serviceWorker from './serviceWorker';
import { loadAppConfig } from './lib/constants';
import './scss/index.css';
import 'react-toastify/dist/ReactToastify.css';
import 'tabler-react/dist/Tabler.css';
import './scss/App.scss';

// Load runtime config before rendering so all env-dependent values are set.
loadAppConfig().then(() => {
  const root = createRoot(document.getElementById('root'));
  root.render(<Root />);
});
serviceWorker.unregister();
